export default __webpack_public_path__ + "static/media/building-icon-color.af5cce94.svg";